import type {
  MembershipOrganization,
  ResearcherMembershipsResult,
} from '@/utils/session/fetch-researcher-memberships';

export type WorkspaceOptions =
  | { status: 'lookup-failed' }
  | { status: 'no-organizations' }
  | { status: 'no-teams' }
  | { status: 'choose'; memberships: MembershipOrganization[] };

type SessionMembership = { organizationId: string; teamId: string };

export function decideWorkspaceOptions(
  result: ResearcherMembershipsResult,
  ownMemberships: SessionMembership[],
): WorkspaceOptions {
  if (!result.ok) return { status: 'lookup-failed' };

  if (result.organizations.some((org) => org.teamsUnavailable)) {
    return { status: 'lookup-failed' };
  }

  if (result.organizations.length === 0) return { status: 'no-organizations' };

  const memberships: MembershipOrganization[] = [];
  for (const org of result.organizations) {
    const teams = org.teams.filter((team) =>
      ownMemberships.some(
        (membership) =>
          membership.organizationId === org.id && membership.teamId === team.id,
      ),
    );
    if (teams.length > 0) memberships.push({ ...org, teams });
  }

  if (memberships.length === 0) return { status: 'no-teams' };

  return { status: 'choose', memberships };
}

export function selectableTeams(
  workspaces: Extract<WorkspaceOptions, { status: 'choose' }>,
): SessionMembership[] {
  return workspaces.memberships.flatMap((org) =>
    org.teams.map((team) => ({ organizationId: org.id, teamId: team.id })),
  );
}
